/**
 * Created by zhj on 3/14/2016.
 */
'use strict';
angular.module('telephone', ['ui.router']).config(function ($stateProvider) {
  $stateProvider
    .state('telephones', {
      parent: 'betotrack',
      abstract: true,
      url: '/telephone',
      ncyBreadcrumb: {
        skip: true
      }
    }).state('telephones.list', {
      url: '/list',
      views: {
        'content@app': {
          controller: 'TelephoneCtrl',
          templateUrl: 'components/track/telephone/telephoneList.tpl.html'
        }
      },
      ncyBreadcrumb: {
        label: 'telephonesList.moduleName'
      }
    }).state('telephones.new', {
      url: '/new',
      views: {
        'content@app': {
          controller: 'TelephoneEditCtrl',
          templateUrl: 'components/track/telephone/telephoneOperate.tpl.html'
        }
      },
      resolve: {
        editorModel: function (telephoneService) {               
          return {
            mode: 'new',
            getTelephone: telephoneService.getNewTelephone(),
            save: function (telephoneDetail) {           
              return telephoneService.saveTelephone(telephoneDetail);
            }
          };
        }
      },
      ncyBreadcrumb: {
        parent: 'telephones.list',
        label: 'telephoneNew.new'
      }
    }).state('telephones.edit',{
      url: '/{telephoneNumber}/edit',
      params: {
        key: null,
        firstName: null,
        lastName: null,
        fullName: null,
        telephoneNumber: null
      },
      views: {
        'content@app': {
          controller: 'TelephoneEditCtrl',
          templateUrl: 'components/track/telephone/telephoneOperate.tpl.html'
        }
      },
      resolve: {
        editorModel: function (telephoneService, $stateParams) {
          return {
            mode: 'edit',
            getTelephone: telephoneService.getTelephoneDetail($stateParams),
            save: function (telephoneDetail) {
              return telephoneService.updateTelephone(telephoneDetail);
            }
          };
        }
      },
      ncyBreadcrumb: {
        parent: 'telephones.list',
        label: '{{telephoneNumber}}'
      }
    }).state('telephones.copy',{
      url: '/{telephoneNumber}/copy',
      params: {
        key : null,
        firstName: null,
        lastName: null,
        fullName: null,
        telephoneNumber: null
      },
      views: {
        'content@app': {
          controller: 'TelephoneEditCtrl',
          templateUrl: 'components/track/telephone/telephoneOperate.tpl.html'
        }
      },
      resolve: {
        editorModel: function (telephoneService, $stateParams) {
          return {
            mode: 'copy',
            getTelephone: telephoneService.getCopyTelephone($stateParams.key),
            save: function (telephoneDetail) {
              return telephoneService.saveTelephone(telephoneDetail);
            }
          };
        }
      },
      ncyBreadcrumb: {
        parent: 'telephones.list',
        label: 'telephoneNew.copy'
      }
    });
});



// WEBPACK FOOTER //
// ./.tmp/components/track/telephone/telephone.js